import { render, staticRenderFns } from "./IncidentReport.vue?vue&type=template&id=0adccdc9&scoped=true"
import script from "./IncidentReport.vue?vue&type=script&lang=ts"
export * from "./IncidentReport.vue?vue&type=script&lang=ts"
import style0 from "./IncidentReport.vue?vue&type=style&index=0&id=0adccdc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adccdc9",
  null
  
)

export default component.exports